<template>
    <div class="recuadro">
        <h1>{{ this.errorCode }} - {{ this.errorMessage }}</h1>
        <p>Lo sentimos, ha ocurrido un error inesperado. Por favor, inténtelo de nuevo más tarde.</p>
        <img :src="`/${this.imageName}`" alt="Error Image" />
    </div>
</template>
<style src="../assets/general.css"></style>
<script>
/* eslint-disable */
    export default {
        name: 'Error',
        props: {
            errorMessage: {
                type: String,
                default: 'Sistema en mantenimiento'
            },
            errorCode: {
                type: String,
                default: '503'
            },
            imageName: {
                type: String,
                default: 'error-503.png'
            },
        }
    }
</script>